import Vue from 'vue';

import DuiNotification, { NOTIFICATION_TYPES } from '@dui/components/dui-notification/dui-notification.vue';
import SASS from '@dui/helpers/sass';

const NotificationClass = Vue.extend(DuiNotification);

const DEFAULT_DISPLAY_TIME = 5000;

export class DuiNotificationManager {
  constructor() {
    this._notificationsPanelEl = document.createElement('div');
    this._notificationsPanelEl.classList.add('dui-notifications-panel');
    document.body.appendChild(this._notificationsPanelEl);
  }

  _notify(type, message, url, persistent, timer) {
    if (!message) return;

    timer = timer || DEFAULT_DISPLAY_TIME;

    const duiNotification = new NotificationClass({
      propsData: {
        url,
        message,
        type,
      },
    });
    duiNotification.$mount();
    this._notificationsPanelEl.appendChild(duiNotification.$el);

    if (persistent !== true) {
      this._setNotificationTimer(duiNotification, timer);
    }

    return duiNotification;
  }

  _setNotificationTimer(duiNotification, timer) {
    setTimeout(() => {
      this.destroyNotification(duiNotification);
    }, timer);
  }

  error(message, url, persistent = false, timer) {
    // Parse Error objects
    if (typeof message === 'object' && message.message) {
      message = message.message;
    }

    return this._notify(NOTIFICATION_TYPES.error, message, url, persistent, timer);
  }

  message(message, url, persistent = false, timer) {
    return this._notify(NOTIFICATION_TYPES.message, message, url, persistent, timer);
  }

  success(message, url, persistent = false, timer) {
    return this._notify(NOTIFICATION_TYPES.success, message, url, persistent, timer);
  }

  destroyNotification(duiNotification) {
    duiNotification.$el.classList.add('closing');

    setTimeout(() => {
      duiNotification.$destroy();
      duiNotification.$el.remove();
    }, SASS.transitionTime.base);
  }

  updateNotification(duiNotification, message, type = null) {
    duiNotification.message = message;

    if (type && NOTIFICATION_TYPES[type]) {
      duiNotification.type = type;
    }
  }
}


export default {
  install: function(Vue, options) {
    Vue.duiNotificationManager = new DuiNotificationManager();
  },
};
